import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u09AC\u09BE\u0982\u09B2\u09BE",
  code: "bn",
  messages: {
    alert: {
      close: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"
    },
    authForm: {
      hidePassword: "\u09AA\u09BE\u09B8\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u09A1 \u09B2\u09C1\u0995\u09BE\u09A8",
      showPassword: "\u09AA\u09BE\u09B8\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u09A1 \u09A6\u09C7\u0996\u09BE\u09A8",
      submit: "\u099A\u09BE\u09B2\u09BF\u09AF\u09BC\u09C7 \u09AF\u09BE\u09A8"
    },
    banner: {
      close: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"
    },
    calendar: {
      nextMonth: "\u09AA\u09B0\u09AC\u09B0\u09CD\u09A4\u09C0 \u09AE\u09BE\u09B8",
      nextYear: "\u09AA\u09B0\u09AC\u09B0\u09CD\u09A4\u09C0 \u09AC\u099B\u09B0",
      prevMonth: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09AC\u09B0\u09CD\u09A4\u09C0 \u09AE\u09BE\u09B8",
      prevYear: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09AC\u09B0\u09CD\u09A4\u09C0 \u09AC\u099B\u09B0"
    },
    carousel: {
      dots: "\u09AA\u09CD\u09B0\u09A6\u09B0\u09CD\u09B6\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u09B8\u09CD\u09B2\u09BE\u0987\u09A1 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8",
      goto: "\u09B8\u09CD\u09B2\u09BE\u0987\u09A1 {slide} \u098F \u09AF\u09BE\u09A8",
      next: "\u09AA\u09B0\u09AC\u09B0\u09CD\u09A4\u09C0",
      prev: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09AC\u09B0\u09CD\u09A4\u09C0"
    },
    chatPrompt: {
      placeholder: "\u098F\u0996\u09BE\u09A8\u09C7 \u0986\u09AA\u09A8\u09BE\u09B0 \u09AC\u09BE\u09B0\u09CD\u09A4\u09BE \u09B2\u09BF\u0996\u09C1\u09A8..."
    },
    chatPromptSubmit: {
      label: "\u09AA\u09CD\u09B0\u09C7\u09B0\u09A3 \u0995\u09B0\u09C1\u09A8"
    },
    colorMode: {
      dark: "\u0997\u09BE\u09A2\u09BC",
      light: "\u09B9\u09BE\u09B2\u0995\u09BE",
      switchToDark: "\u0997\u09BE\u09A2\u09BC \u09AE\u09CB\u09A1\u09C7 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0995\u09B0\u09C1\u09A8",
      switchToLight: "\u09B9\u09BE\u09B2\u0995\u09BE \u09AE\u09CB\u09A1\u09C7 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0995\u09B0\u09C1\u09A8",
      system: "\u09B8\u09BF\u09B8\u09CD\u099F\u09C7\u09AE"
    },
    commandPalette: {
      back: "\u09AA\u09C7\u099B\u09A8\u09C7",
      close: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8",
      noData: "\u0995\u09CB\u09A8 \u09A4\u09A5\u09CD\u09AF \u09A8\u09C7\u0987",
      noMatch: "\u0995\u09CB\u09A8 \u09AE\u09BF\u09B2 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF",
      placeholder: "\u0995\u09AE\u09BE\u09A8\u09CD\u09A1 \u099F\u09BE\u0987\u09AA \u0995\u09B0\u09C1\u09A8 \u09AC\u09BE \u0985\u09A8\u09C1\u09B8\u09A8\u09CD\u09A7\u09BE\u09A8 \u0995\u09B0\u09C1\u09A8..."
    },
    contentSearch: {
      links: "\u09B2\u09BF\u0982\u0995\u09B8\u09AE\u09C2\u09B9",
      theme: "\u09A5\u09BF\u09AE"
    },
    contentSearchButton: {
      label: "\u0985\u09A8\u09C1\u09B8\u09A8\u09CD\u09A7\u09BE\u09A8 \u0995\u09B0\u09C1\u09A8..."
    },
    contentToc: {
      title: "\u098F\u0987 \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09AF\u09BC"
    },
    dashboardSearch: {
      theme: "\u09A5\u09BF\u09AE"
    },
    dashboardSearchButton: {
      label: "\u0985\u09A8\u09C1\u09B8\u09A8\u09CD\u09A7\u09BE\u09A8 \u0995\u09B0\u09C1\u09A8..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u09B8\u09BE\u0987\u09A1\u09AC\u09BE\u09B0 \u09B8\u0982\u0995\u09C1\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8",
      expand: "\u09B8\u09BE\u0987\u09A1\u09AC\u09BE\u09B0 \u09AA\u09CD\u09B0\u09B8\u09BE\u09B0\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8"
    },
    dashboardSidebarToggle: {
      close: "\u09B8\u09BE\u0987\u09A1\u09AC\u09BE\u09B0 \u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8",
      open: "\u09B8\u09BE\u0987\u09A1\u09AC\u09BE\u09B0 \u0996\u09C1\u09B2\u09C1\u09A8"
    },
    error: {
      clear: "\u09B9\u09CB\u09AE \u09AA\u09C7\u099C\u09C7 \u09AB\u09BF\u09B0\u09C7 \u09AF\u09BE\u09A8"
    },
    fileUpload: {
      removeFile: "{filename} \u09B8\u09B0\u09BE\u09A8"
    },
    header: {
      close: "\u09AE\u09C7\u09A8\u09C1 \u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8",
      open: "\u09AE\u09C7\u09A8\u09C1 \u0996\u09C1\u09B2\u09C1\u09A8"
    },
    inputMenu: {
      create: '"{label}" \u09A4\u09C8\u09B0\u09BF \u0995\u09B0\u09C1\u09A8',
      noData: "\u0995\u09CB\u09A8 \u09A4\u09A5\u09CD\u09AF \u09A8\u09C7\u0987",
      noMatch: "\u0995\u09CB\u09A8 \u09AE\u09BF\u09B2 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF"
    },
    inputNumber: {
      decrement: "\u09B9\u09CD\u09B0\u09BE\u09B8 \u0995\u09B0\u09C1\u09A8",
      increment: "\u09AC\u09C3\u09A6\u09CD\u09A7\u09BF \u0995\u09B0\u09C1\u09A8"
    },
    modal: {
      close: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"
    },
    pricingTable: {
      caption: "\u09AA\u09CD\u09B0\u09BE\u0987\u09B8\u09BF\u0982 \u09AA\u09CD\u09B2\u09CD\u09AF\u09BE\u09A8\u09C7\u09B0 \u09A4\u09C1\u09B2\u09A8\u09BE"
    },
    prose: {
      codeCollapse: {
        closeText: "\u09B8\u0982\u0995\u09C1\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8",
        name: "\u0995\u09CB\u09A1",
        openText: "\u09AA\u09CD\u09B0\u09B8\u09BE\u09B0\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8"
      },
      collapsible: {
        closeText: "\u09B2\u09C1\u0995\u09BE\u09A8",
        name: "\u09AC\u09C8\u09B6\u09BF\u09B7\u09CD\u099F\u09CD\u09AF\u09B8\u09AE\u09C2\u09B9",
        openText: "\u09A6\u09C7\u0996\u09BE\u09A8"
      },
      pre: {
        copy: "\u0995\u09CB\u09A1 \u0995\u09CD\u09B2\u09BF\u09AA\u09AC\u09CB\u09B0\u09CD\u09A1\u09C7 \u0995\u09AA\u09BF \u0995\u09B0\u09C1\u09A8"
      }
    },
    selectMenu: {
      create: '"{label}" \u09A4\u09C8\u09B0\u09BF \u0995\u09B0\u09C1\u09A8',
      noData: "\u0995\u09CB\u09A8 \u09A4\u09A5\u09CD\u09AF \u09A8\u09C7\u0987",
      noMatch: "\u0995\u09CB\u09A8 \u09AE\u09BF\u09B2 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF",
      search: "\u0985\u09A8\u09C1\u09B8\u09A8\u09CD\u09A7\u09BE\u09A8 \u0995\u09B0\u09C1\u09A8..."
    },
    slideover: {
      close: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"
    },
    table: {
      noData: "\u0995\u09CB\u09A8 \u09A4\u09A5\u09CD\u09AF \u09A8\u09C7\u0987"
    },
    toast: {
      close: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"
    }
  }
});
